import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Dialog} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const PigmentNotification = ({
  children,
  dismiss,
  title,
  width = 'md',
  // 'name' is used in NotificationSwitcher to find the corresponding component

  name
}) => {
  const containerRef = useRef(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setIsMounted(true);
    }
  }, []);

  const handleClose = () => {
    dismiss && dismiss();
  };

  const handleMouseDown = evt => {
    evt.stopPropagation();
  };

  return (
    <div ref={containerRef}>
      {isMounted && (
        <Dialog
          open
          onClose={handleClose}
          title={title}
          onMouseDown={handleMouseDown}
          width={width}
          container={() => containerRef.current}
          hideBackdrop
          disablePortal>
          {children}
        </Dialog>
      )}
    </div>
  );
};

PigmentNotification.displayName = 'PigmentNotification';

const propTypes = {
  children: PropTypes.node,
  dismiss: PropTypes.func,
  title: PropTypes.node,
  width: PropTypes.oneOf(['sm', 'md', 'lg', 'full'])
};

PigmentNotification.propTypes = propTypes;

export default PigmentNotification;
